import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useValidatedAmounts = (selectedDate: Date | undefined) => {
  return useQuery({
    queryKey: ["validatedAmounts", selectedDate],
    queryFn: async () => {
      let query = supabase
        .from("validated_amounts")
        .select("*")
        .order("counting_date", { ascending: false });

      if (selectedDate) {
        // Ajuster la date pour tenir compte du fuseau horaire
        const date = new Date(selectedDate);
        date.setHours(12, 0, 0, 0); // Set to noon to avoid timezone issues
        const formattedDate = date.toISOString().split("T")[0];
        query = query.eq("counting_date", formattedDate);
      }

      const { data, error } = await query;

      if (error) {
        console.error("Error fetching validated amounts:", error);
        throw error;
      }

      return data || [];
    },
    refetchInterval: 30000,
  });
};